import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CommonCommunicationService } from './common-communication.service';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RatingQuestionsService {
    questionsApi: string = environment.backend + environment.uri.questions;
    getSciCyberQuestionsApi: string =
        environment.backend + environment.uri.scicybergetuwq;
    eligibilityApi: string = '../../assets/json/rating-questions-data.json';

    constructor(
        private _http: HttpClient,
        private _ccs: CommonCommunicationService
    ) {}

    getRatingsData(classification_id, productId) {
        return this._http.get<any>(
            this.questionsApi
                .replace('#PARTNER#', this._ccs.PartnerId)
                .replace('$classid$', classification_id)
                .replace('$productid$', productId)
        );
    }

    getEligibilityQuestions() {
        return this._http.get<any>(this.eligibilityApi).pipe(
            catchError((error: Response) => {
                return observableThrowError(error);
            })
        );
    }

    getSciCyberUWQuestions(questionsPayload) {
        return this._http
            .post<any>(this.getSciCyberQuestionsApi, questionsPayload)
            .pipe(
                catchError((error: Response) => {
                    return observableThrowError(error);
                })
            );
    }
}
